import { useEffect } from 'react';

/**
 * Locks the page behind a modal from scrolling while `locked` is true. A caller that never locks
 * (`locked` stays `false` for its whole lifetime, e.g. an embedded instance that isn't the one
 * holding the lock) must not touch `overflowY` at all — unmounting it would otherwise clear a lock
 * a sibling is still holding, since only the effect that set it registers a cleanup.
 */
export function useLockBodyScroll(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = '';
    };
  }, [locked]);
}
